var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickBuy = function SvgQuickBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.335 9.5c1.116 0 2.057.356 2.82 1.067.765.713 1.156 1.61 1.174 2.693v.513h3.992v6.36h-1.803v-4.558h-2.19v3.09h-1.802v-3.09h-4.38v3.09h-1.804v-3.09h-2.19v12.36h7.38v1.803H11.35V13.773h3.992v-.513c.018-1.082.409-1.98 1.173-2.693.764-.711 1.704-1.067 2.82-1.067Zm0 1.802c-.6 0-1.112.18-1.533.54-.42.36-.639.834-.656 1.418v.513h4.38v-.513c-.017-.584-.237-1.057-.657-1.417-.421-.361-.933-.541-1.534-.541Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.596 22.526h1.502V30.5h-1.502z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.25 25.762v1.502h-7.978v-1.502z"
  })));
};
export default SvgQuickBuy;